export default class Plan {
  constructor(_id, title, description, period, disabled) {
    // eslint-disable-next-line no-underscore-dangle
    this._id = _id
    this.title = title
    this.description = description
    this.period = period
    this.disabled = disabled
  }
}
